/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IFreedomNavViewProps } from './freedom-nav-item';

/**
 *
 * FreedomNavItemView component.
 * @extends {React.PureComponent<IFreedomNavViewProps>}
 */
export class FreedomNavItemView extends React.PureComponent<IFreedomNavViewProps> {
    public render(): JSX.Element | null {
        const { FreedomNavItem } = this.props;
        return (
            <Module {...FreedomNavItem}>
                {this._renderElement(this.props)}
            </Module>
        );
    }

    private _renderElement(props: IFreedomNavViewProps): React.ReactNode | null {
        const { heading, HeadingContainer, Link, linkText, image, text, EditableLink } = props;
        if (heading) {
            return (<Node {...HeadingContainer}>
                {' '}
                {heading}
                {' '}
            </Node>);
        } else if (Link && image) {
            return (
                <Node {...Link}>
                    {linkText}
                    {image}
                </Node>
            );
        } else if (Link) {
            return (EditableLink);
        }
        return (
            <>
                {text}
                {image}
            </>
        );
    }
}

export default FreedomNavItemView;
